import { request } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function getAños(dispatch) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/year/list/all`,
		method: "GET",
	}, dispatch);
}
export function updateStatus(dispatch,year) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/year/change/status/${year}`;
	return request({
		url: url,
		method: "PUT",
	}, dispatch);
}
export function crearAños(dispatch, year) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/year/crear/${year}`,
		method: "POST",
	}, dispatch);
}